export const Constants = {
  TAG_NAME: 'pop-team-member-component',
  BEACON_SYSTEM_BREAKPOINT_X_LARGE: '--beacon-system-breakpoint-x-large',
  NORMAL: 'normal',
  MINI: 'mini',
  VIEW_BIO: 'View Bio',
  DISCOVER_INSIGHTS: 'Discover Insights',
} as const;
